import http from "@/http-common";

export default class LoginLogService {

	getList(_params) {
		return http.get('/cm/loginlogs', { params: _params}).then(res => res.data);
	}

	insertOne(_data) {
		return http.post('/cm/loginlogs',_data).then(res => res.data);
	}

	updateOne(_data) {
		return http.patch('/cm/loginlogs/',_data).then(res => res.data);
	}

}